import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/novelcraft/tek_img_08.webp";
import { StaticImage } from "gatsby-plugin-image";

function SolNovel() {
  return (
    <section
      className="solution_sec_novel p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="mx-auto text-center"
          >
            <h2>The Solution</h2>
            <p>
              We designed the entire game on Unity 3D and implemented a systemic
              sequence of algorithms, based on the choices that players could
              make. We were able to create an exquisite collaboration of the
              chararcters and the world around them. Our artists created
              detailed background settings and displays that defined the game
              environment and provides a flow of captivating affairs for players
              to engage with.
            </p>
            <div className="img_novel">
              <StaticImage
                src="../../../images/case-studies/novelcraft/tek_img_09.webp"
                alt="TekRevol Novelcraft"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1390}
                height={1595}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default SolNovel;
